import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import someModuleEN from '@shared/locales/en/somemodule';
import commonEN from '@shared/locales/en/common';
import publicEN from '@shared/locales/en/public';
import privateEN from '@shared/locales/en/private';

const resources = {
  en: {
    translation: commonEN, // default and common
    someModule: someModuleEN,
    public: publicEN,
    private: privateEN,
  }
};

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // To detect browser, add i18next-browser-languagedetector and uncomment
  // .use(I18nextBrowserLanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: 'en',
    lng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

export default i18n;
